var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.loading ? _c('div', {
    staticClass: "card mb-4"
  }, [_vm.report.length === 0 ? _c('div', {
    staticClass: "card-body"
  }, [_vm._v("Rapport \"" + _vm._s(this.identifier) + "\" is niet beschikbaar ")]) : _vm._e(), _vm._l(_vm.report, function (item, index) {
    return _c('div', {
      key: 'report_item_' + index,
      staticClass: "card-body"
    }, [_c('iframe', {
      staticClass: "metabase",
      class: item.css_class,
      attrs: {
        "src": item.url + '#bordered=false',
        "height": (item.height ? item.height : '400') + 'px',
        "width": "100%"
      }
    })]);
  })], 2) : _c('div', {
    staticClass: "card mb-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }